export default [
    {
        path: '/price/overview/:initialIdentifier?',
        name: 'price_overview',
        component: () => import('@src/price-product/price-overview/price-overview'),
        props(route) {
            if (!route.params.initialIdentifier) {
                route.params.initialIdentifier = null;
            }
            return { ...route.params };
        },
        meta: {
            title: 'Preisübersicht',
            role: 'ROLE_OVERVIEW_PRICE',
        },
    },
    {
        path: '/price-set/list',
        name: 'price_set_list',
        component: () => import('@src/price-product/price-set/price-set-list'),
        meta: {
            title: 'Preisabfrage',
            role: 'ROLE_LIST_PRICE_SET',
        },
    },
    {
        path: '/price-set/create/:idInitialPriceSet?',
        name: 'price_set_create',
        component: () => import('@src/price-product/price-set/price-set.vue'),
        props(route) {
            return { idInitialPriceSet: route.params.idInitialPriceSet ? Number.parseInt(route.params.idInitialPriceSet) : null };
        },
        meta: {
            title: 'Preisabfrage erstellen',
            role: 'ROLE_EDIT_PRICE_SET',
        },
    },
    {
        path: '/price-set/edit/:id',
        name: 'price_set_edit',
        component: () => import('@src/price-product/price-set/price-set.vue'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'Preisabfrage bearbeiten',
            role: 'ROLE_EDIT_PRICE_SET',
        },
    },
    {
        path: '/price-promotion/list',
        name: 'price_promotion_list',
        component: () => import('@src/price-product/price-promotion/price-promotion-list'),
        meta: {
            title: 'Preisaktionen',
            role: 'ROLE_LIST_PRICE_PROMOTION',
        },
    },
    {
        path: '/price-promotion/edit/:id',
        name: 'price_promotion_edit',
        component: () => import('@src/price-product/price-promotion/price-promotion.vue'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'Preisaktion bearbeiten',
            role: 'ROLE_EDIT_PRICE_PROMOTION',
        },
    },
    {
        path: '/price-promotion/create/:idCopyFrom?',
        name: 'price_promotion_create',
        component: () => import('@src/price-product/price-promotion/price-promotion.vue'),
        props(route) {
            return { idCopyFrom: route.params.idCopyFrom ? Number.parseInt(route.params.idCopyFrom) : null };
        },
        meta: {
            title: 'Preisaktion anlegen',
            role: 'ROLE_EDIT_PRICE_PROMOTION',
        },
    },
    {
        path: '/procurement/missing-cost-prices',
        name: 'procurement_missing_cost_prices',
        component: () => import('@src/procurement/missing-cost-price-list'),
        meta: {
            title: 'EK nachtragen',
            role: 'ROLE_EDIT_PRICE',
        },
    },
    {
        path: '/procurement/edit-missing-cost-prices/:selection',
        name: 'procurement_edit_missing_cost_prices',
        component: () => import('@src/procurement/edit-missing-cost-prices'),
        props(route) {
            return {
                selection: JSON.parse(decodeURIComponent(route.params.selection)),
            };
        },
        meta: {
            title: 'EK nachtragen',
            role: 'ROLE_EDIT_PRICE',
        },
    },
    {
        path: '/price-reset-recommendation/list',
        name: 'price_reset_recommendation_list',
        component: () => import('@src/price-product/price-reset-recommendations/price-reset-recommendations-list'),
        meta: {
            title: 'Preise zurücksetzen',
            role: 'ROLE_LIST_PRICE_PROMOTION',
        },
    },
    {
        path: '/damaged-product/price-promotion/list',
        name: 'damaged_price_promotion_list',
        component: () => import('@src/price-product/damaged-price-promotion/damaged-price-promotion-list'),
        meta: {
            title: 'B-Ware Preisaktionen',
            role: 'ROLE_LIST_DAMAGED_PRICE_PROMOTION',
        },
    },
    {
        path: '/damaged-product/price-promotion/create',
        name: 'damaged_price_promotion_create',
        component: () => import('@src/price-product/damaged-price-promotion/damaged-price-promotion.vue'),
        meta: {
            title: 'B-Ware Preisaktion anlegen',
            role: 'ROLE_EDIT_DAMAGED_PRICE_PROMOTION',
        },
    },
    {
        path: '/damaged-product/price-promotion/edit/:id',
        name: 'damaged_price_promotion_edit',
        component: () => import('@src/price-product/damaged-price-promotion/damaged-price-promotion.vue'),
        meta: {
            title: 'B-Ware Preisaktion bearbeiten',
            role: 'ROLE_EDIT_DAMAGED_PRICE_PROMOTION',
        },
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
    },
    {
        path: '/show-suggested-retail-price-filter/list',
        name: 'show_suggested_retail_price_filter_list',
        component: () => import('@src/price-product/show-suggested-retail-price-filter/list.vue'),
        meta: {
            title: 'Streichpreisfilter',
            role: 'ROLE_SHOW_SUGGESTED_RETAIL_PRICE_FILTER',
        },
    },
    {
        path: '/show-suggested-retail-price-filter/create',
        name: 'show_suggested_retail_price_filter_create',
        component: () => import('@src/price-product/show-suggested-retail-price-filter/create.vue'),
        meta: {
            title: 'Streichpreisfilter anlegen',
            role: 'ROLE_SHOW_SUGGESTED_RETAIL_PRICE_FILTER',
        },
    },
    {
        path: '/show-suggested-retail-price-filter/edit/:id',
        name: 'show_suggested_retail_price_filter_edit',
        component: () => import('@src/price-product/show-suggested-retail-price-filter/edit.vue'),
        meta: {
            title: 'Streichpreisfilter bearbeiten',
            role: 'ROLE_SHOW_SUGGESTED_RETAIL_PRICE_FILTER',
        },
        props({ params }) {
            return {
                id: Number(params.id),
            };
        },
    },
];
